<template>
  <div>
    <v-row dense>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.NMRP"
            outlined
            dense
            :label="$t('training_builder.text_input.num_of_repetitions.title')"
            :placeholder="$t('label.e_g') + ' ' + 10"
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
      <v-col>
        <minute-second-input
          :value="dirtySetParams.RPWRDR"
          :label="$t('training_builder.text_input.rep_work_period.title')"
          variable="RPWRDR"
          @input="handleDurationInput"
        />
      </v-col>
      <v-col>
        <minute-second-input
          :value="dirtySetParams.RPRSDR"
          :label="$t('training_builder.text_input.rep_rest_period.title')"
          variable="RPRSDR"
          @input="handleDurationInput"
        />
      </v-col>
    </v-row>

    <v-divider class="mb-6" />

    <v-row dense>
      <v-col cols="6">
        <minute-second-input
          :value="dirtySetParams.RSSTDR"
          :label="$t('training_builder.text_input.rest_time_after_set')"
          variable="RSSTDR"
          @input="handleDurationInput"
        />
      </v-col>
    </v-row>

    <v-divider class="mb-6" />

    <v-row dense>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.CNTDR"
            outlined
            dense
            :label="$t('training_builder.text_input.contraction_duration.title')"
            :placeholder="$t('label.e_g') + ' ' + 5"
            :decimal-precision="0"
            suffix="s"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.RLDR"
            outlined
            dense
            :label="$t('training_builder.text_input.relaxation_duration.title')"
            :placeholder="$t('label.e_g') + ' ' + 5"
            :decimal-precision="0"
            suffix="s"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NumberInput from '@/components/helpers/NumberInput.vue'
import { cloneVariables } from '@/components/training-builder/helpers'
import MinuteSecondInput from '@/components/helpers/MinuteSecondInput.vue'

export default {
  name: 'MobilityParamsEntry',
  components: { MinuteSecondInput, NumberInput },
  props: {
    exercise: {
      type: Object,
      required: true
    },
    setParams: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dirtySetParams: cloneVariables(this.setParams)
    }
  },
  watch: {
    dirtySetParams: {
      deep: true,
      handler: function (newValue) {
        this.$emit('update:setParams', newValue)
      }
    }
  },
  methods: {
    handleDurationInput(min, sec, variable) {
      this.dirtySetParams[variable] = min * 60 + sec > 0 ? min * 60 + sec : null
    }
  }
}
</script>
